import styled, { css, keyframes } from 'styled-components';

export const FilterRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 20px;

  /* Dropdowns Semantic (ex.: Unidade) — opções sem negrito */
  .ui.dropdown .menu > .item,
  .ui.selection.dropdown {
    font-weight: 400 !important;
  }
`;

export const FilterBarRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  width: 100%;
`;

export const FieldGroup = styled.div<{ flex?: number; minWidth?: number }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: ${props => props.flex || 1};
  min-width: ${props => (props.minWidth ? `${props.minWidth}px` : '140px')};

  @media (max-width: 768px) {
    flex: 1 1 100%;
    min-width: 100%;
  }
`;

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #4a4a4a;
  cursor: default;
`;

export const ActionsGroup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
  padding-bottom: 0;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-end;
  }
`;

export const IconButton = styled.button<{
  primary?: boolean;
  disabled?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid
    ${props =>
      props.primary
        ? props.theme.main.color
        : props.disabled
        ? '#e0e0e0'
        : '#d4d4d5'};
  background: ${props =>
    props.primary
      ? props.theme.main.color
      : props.disabled
      ? '#f5f5f5'
      : '#ffffff'};
  color: ${props => (props.primary ? '#ffffff' : props.disabled ? '#bbb' : '#888')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  padding: 0;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  i.icon {
    margin: 0 !important;
  }
`;

export const MoreFiltersButton = styled.button<{ active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 14px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.main.color};
  background: #ffffff;
  color: ${props => props.theme.main.color};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  transition: background 0.15s ease;

  &:hover {
    background: #f8f4fc;
  }

  i.icon {
    margin: 0 !important;
  }
`;

export const BadgeCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: ${props => props.theme.main.color};
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`;

export const ControlBase = css`
  display: flex;
  align-items: center;
  min-height: 38px;
  border: 1px solid #d4d4d5;
  border-radius: 6px;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: ${props => props.theme.main.color};
    box-shadow: 0 0 0 1px ${props => props.theme.main.color};
  }
`;

export const SearchFieldContainer = styled.div`
  ${ControlBase};
  padding: 0 4px 0 4px;
  gap: 4px;
  overflow: hidden;
`;

export const SearchTypePill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 50%;
  height: 28px;
  padding: 0 8px;
  border: none;
  border-radius: 4px;
  background: #f3edfc;
  color: ${props => props.theme.main.color};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;

  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  i.icon {
    flex: 0 0 auto;
  }

  &:hover {
    background: #e9dff9;
  }
`;

export const SearchTypeMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 40;
  min-width: 200px;
  max-height: 280px;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
`;

export const SearchTypeOption = styled.button<{ selected?: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border: none;
  background: ${props => (props.selected ? '#f3edfc' : 'transparent')};
  color: ${props => (props.selected ? props.theme.main.color : '#333')};
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;

  &:hover {
    background: #f3edfc;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 8px 10px;
  font-size: 14px;
  color: #333;
  min-width: 0;

  &::placeholder {
    color: #999;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const TextControl = styled.input`
  ${ControlBase};
  width: 100%;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  outline: none;

  &::placeholder {
    color: #999;
  }

  &:disabled {
    background: #f5f8fa;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const DateRangeTrigger = styled.button<{ open?: boolean; hasValue?: boolean }>`
  ${ControlBase};
  width: 100%;
  padding: 0 12px;
  gap: 8px;
  cursor: pointer;
  color: ${props => (props.hasValue ? '#333' : '#999')};
  font-size: 14px;
  text-align: left;

  ${props =>
    props.open &&
    css`
      border-color: ${p => p.theme.main.color};
      box-shadow: 0 0 0 1px ${p => p.theme.main.color};
    `}

  i.icon {
    margin: 0 !important;
    color: #888;
  }
`;

export const DateRangeValue = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PopoverPanel = styled.div<{
  mobile?: boolean;
  width?: number;
}>`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.16);
  border: 1px solid #ececec;
  z-index: 1000;
  overflow: visible;

  .ui.dropdown .menu > .item,
  .ui.selection.dropdown {
    font-weight: 400 !important;
  }

  ${props =>
    props.mobile
      ? css`
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          max-height: 85vh;
          border-radius: 16px 16px 0 0;
          overflow-y: auto;
        `
      : css`
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          width: ${props.width ? `${props.width}px` : 'auto'};
          min-width: 280px;
        `}
`;

export const PopoverOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 999;
`;

export const AdvancedHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ececec;
  background: #ffffff;
  border-radius: 8px 8px 0 0;
  position: relative;
  z-index: 1;
`;

export const AdvancedTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #333;

  i.icon {
    margin: 0 !important;
    color: ${props => props.theme.main.color};
  }
`;

export const AdvancedCloseButton = styled.button`
  border: none;
  background: transparent;
  color: #aaa;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  font-size: 16px;

  &:hover {
    color: #666;
  }

  i.icon {
    margin: 0 !important;
  }
`;

export const AdvancedBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  max-height: 360px;
  overflow-y: auto;
  position: relative;
  z-index: 2;
`;

export const AdvancedFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #ececec;
  background: #ffffff;
  position: relative;
  z-index: 1;
  border-radius: 0 0 8px 8px;
`;

export const OutlineButton = styled.button`
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.main.color};
  background: #ffffff;
  color: ${props => props.theme.main.color};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f8f4fc;
  }
`;

export const PrimaryButton = styled.button`
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.main.color};
  background: ${props => props.theme.main.color};
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.92;
  }
`;

export const TextButton = styled.button`
  height: 36px;
  padding: 0 12px;
  border: none;
  background: transparent;
  color: #333;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const ChipsIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${props => props.theme.main.color};
  margin-right: 4px;

  i.icon {
    margin: 0 !important;
  }
`;

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid ${props => props.theme.secundary.color};
  background: #f3edfc;
  color: ${props => props.theme.main.color};
  font-size: 12px;
  line-height: 1;
`;

export const ChipLabel = styled.span`
  font-weight: 400;
`;

export const ChipValue = styled.span`
  font-weight: 700;
`;

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: ${props => props.theme.main.color};
  cursor: pointer;
  padding: 0;
  margin-left: 2px;
  line-height: 1;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }

  i.icon {
    margin: 0 !important;
    font-size: 11px !important;
  }
`;

export const DateRangeLayout = styled.div`
  display: flex;
  min-height: 360px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PresetList = styled.div`
  width: 200px;
  border-right: 1px solid #ececec;
  padding: 8px 0;
  overflow-y: auto;
  max-height: 420px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #ececec;
    max-height: 180px;
  }
`;

export const PresetItem = styled.button<{ selected?: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 16px;
  border: none;
  border-left: 3px solid
    ${props => (props.selected ? props.theme.main.color : 'transparent')};
  background: ${props => (props.selected ? '#f3edfc' : 'transparent')};
  color: ${props => (props.selected ? props.theme.main.color : '#333')};
  font-size: 13px;
  cursor: pointer;

  &:hover {
    background: #f8f4fc;
  }
`;

export const DateRangeMain = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  padding: 16px;
`;

export const DateInputsRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
`;

export const DateInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const DateInputLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

export const DateInput = styled.input<{ active?: boolean }>`
  height: 38px;
  padding: 0 12px;
  border: 1px solid ${props => (props.active ? props.theme.main.color : '#d4d4d5')};
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  outline: none;
  box-shadow: ${props =>
    props.active ? `0 0 0 1px ${props.theme.main.color}` : 'none'};

  &:focus {
    border-color: ${props => props.theme.main.color};
    box-shadow: 0 0 0 1px ${props => props.theme.main.color};
  }
`;

export const DateRangeFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: auto;
  padding-top: 12px;
`;

export const CalendarWrapper = styled.div`
  .react-datepicker {
    border: none;
    font-family: inherit;
  }

  .react-datepicker__header {
    background: #ffffff;
    border-bottom: none;
  }

  .react-datepicker__current-month {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    text-transform: capitalize;
    margin-bottom: 8px;
  }

  .react-datepicker__day-name {
    color: #888;
    font-weight: 600;
    width: 2rem;
    line-height: 2rem;
    margin: 0.1rem;
  }

  .react-datepicker__day {
    width: 2rem;
    line-height: 2rem;
    margin: 0.1rem;
    border-radius: 999px;
    color: #333;
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background: #f3edfc !important;
    color: ${props => props.theme.main.color} !important;
    border-radius: 0 !important;
  }

  .react-datepicker__day--range-start,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-end,
  .react-datepicker__day--selected {
    background: ${props => props.theme.main.color} !important;
    color: #ffffff !important;
    border-radius: 999px !important;
  }

  .react-datepicker__day:hover {
    background: #e9dff9;
    border-radius: 999px;
  }

  .react-datepicker__day--outside-month {
    color: #ccc;
  }

  .react-datepicker__navigation {
    top: 12px;
  }
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-height: 38px;
  padding-top: 4px;

  input {
    width: 16px;
    height: 16px;
    accent-color: ${props => props.theme.main.color};
  }
`;

export const RelativeWrap = styled.div`
  position: relative;
  width: 100%;
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const AnimatedPanel = styled.div`
  animation: ${fadeIn} 0.12s ease-out;
`;

export const ChildrenSlot = styled.div`
  width: 100%;
`;
